/**
 * Store some variables that we want to access
 * here and there
 */
export const LOGIN_PATH = 'login'
